<template>
  <div class="non_card__wrap">
    <div v-if="simcard" class="non_card" >
      <div class="header-profile">
        <div v-if="profile.traffic" class="traffic__wrap"
             :title="translate('simcard_profile.balance_traffic') + ': ' + profile.traffic.rest + ' Mb'">
          <div class="traffic" :style="style_traffic">
            <p v-if="profile.traffic.limit && profile.traffic.ts_update">
              <b :style="'color:' + balance_traffic.color"> {{ balance_traffic.traffic }} </b>
              <span>
                {{ translate("simcard_devices.out_of") }}
                <b>
                  {{ profile.traffic.limit > 1024 * 5 ? Math.round(profile.traffic.limit / 1024) + ' GB' :
                    profile.traffic.limit + ' MB' }}
                </b>
              </span>
            </p>
          </div>
          <div class="last_update" v-if="profile.traffic.limit && profile.traffic.ts_update">
            <p>
              {{ translate('simcard_devices.updated') }}
              {{ last_update }}
            </p>
          </div>
        </div>

        <div class="miniblocks">
          <div class="miniblock status_info card" :class="{ online: simcard.active, offline: !simcard.active, }">
            <div class="icons">
              <span class="icon mdi mdi-access-point-off offline" v-if="!simcard.active"/>
              <span class="icon mdi mdi-access-point online" v-if="simcard.active"/>
            </div>

            <div class="text">
              <p>
                {{ simcard.ts_sync === 0 ? translate('simcard_profile.off_forever') : (simcard.active) ? translate('simcard_profile.on_since') : translate('simcard_profile.off_since') }}
              </p>
              <p>
                {{ uptimeStr }}
              </p>
              <p>
                {{ last_date }}
              </p>
            </div>
          </div>

          <div
              class="miniblock simcard_info card"
              :class="global_status_color(+simcard.status)"
          >
            <p>{{ translate(global_status_text(+simcard.status)) }} </p>
            <p>{{ get_status_from }}</p>
            <p>{{ simcard.tariff }}</p>
          </div>
        </div>

        <div class="linked-cards" v-if="Object.keys(links).length > 0">
          <div class="linked-card__wrap" v-for="(link, key) in links" :key="key">
            <LinkedSimCard
              v-if="link != null"
              :title="key"
              :simcard="link"
            />
          </div>
        </div>
      </div>

      <div class="bindings" v-if="simcard.bindings">
        <div class="header">
          <div class="title">
            <h4>{{ translate('simcard_devices.binded_device') }}</h4>
          </div>

          <button
              class="btn-primary btn-fill btn-wd"
              @click.prevent="pre_unlink_simcard()"
          >
              {{ translate('simcard_devices.unlink') }}
            </button>
        </div>

        <div class="card">
          <div class="row">
            <div class="col-md-4">
              <router-link :to="'/device/' + simcard.bindings.device_fid" class="link">
                <fg-input
                    v-model="binding_device"
                    type="text"
                    :label="translate('simcard_devices.in_device')"
                    :placeholder="translate('simcard_devices.in_device')"
                    :readonly="true"
                />
              </router-link>
            </div>

            <div class="col-md-4">
              <fg-input
                  v-model="simcard.bindings.slot"
                  type="text"
                  :label="translate('simcard_devices.slot')"
                  :placeholder="translate('simcard_devices.slot')"
                  :readonly="true"
              />
            </div>

            <div class="col-md-4">
              <fg-input
                  v-model="simcard.bindings.user_name"
                  type="text"
                  :label="translate('simcard_devices.user')"
                  :placeholder="translate('simcard_devices.user')"
                  :readonly="true"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-md-4">
              <fg-input
                  v-model="binding_created"
                  type="text"
                  :label="translate('simcard_devices.created')"
                  :placeholder="translate('simcard_devices.created')"
                  :readonly="true"
              />
            </div>
            <div class="col-md-4">
              <fg-input
                  v-model="binding_updated"
                  type="text"
                  :label="translate('simcard_devices.updated')"
                  :placeholder="translate('simcard_devices.updated')"
                  :readonly="true"
              />
            </div>
            <div class="col-md-4">
              <fg-input
                  v-model="binding_verify"
                  type="text"
                  :label="translate('simcard_devices.verify')"
                  :placeholder="translate('simcard_devices.verify')"
                  :readonly="true"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="content">
        <div class="title">
          <h4>{{ translate('simcard_devices.main_info') }}</h4>
        </div>
        <div class="card">
          <span class="mdi mdi-pen edit" v-if="$store.getters.getPermissions.permissionGod" @click="editProfile"/>
          <div class="line">
            <div class="input_wrap">
              <fg-input
                  v-model="simcard.operator"
                  type="text"
                  :label="translate('simcard_devices.mno')"
                  :placeholder="translate('simcard_devices.mno')"
                  :readonly="true"
              />
            </div>

            <div class="input_wrap">
              <div class="fg-wrapper">
                <fg-input
                    v-model="simcard.msissdn"
                    type="text"
                    :label="translate('simcard_devices.number')"
                    :placeholder="translate('simcard_devices.number')"
                    :readonly="true"
                />
                <div class="mno_link minibtn" v-if="simcard.mno_link">
                  <a :href="simcard.mno_link" target="_blank">
                    <span class="mdi mdi-open-in-new"></span>
                  </a>
                </div>
              </div>
            </div>

            <div class="input_wrap">
              <fg-input v-model="simcard.imsi" type="text" :label="translate('simcard_devices.imsi')"
                        :placeholder="translate('simcard_devices.imsi')" :readonly="true" />
            </div>

            <div class="input_wrap">
              <fg-input v-model="simcard.iccid" type="text" :label="translate('simcard_devices.iccid')"
                        :placeholder="translate('simcard_devices.iccid')" :readonly="true" />
            </div>
          </div>

          <div class="line">
            <div class="input_wrap">
              <router-link :to="'/simcard_devices_groups?group_id=' + simcard_group.id" class="link">
                <fg-input v-model="simcard_group.name" type="text" :label="translate('simcard_devices.group')"
                          :placeholder="translate('simcard_devices.group')" :readonly="true" />
              </router-link>

            </div>

            <div class="input_wrap">
              <fg-input v-model="simcard.tariff" type="text" :label="translate('simcard_devices.tariff')"
                        :placeholder="translate('simcard_devices.tariff')" :readonly="true" />
            </div>

            <div class="input_wrap">
              <fg-input v-model="simcard.tariff_ap" type="text" :label="translate('simcard_devices.tariff_ap')"
                        :placeholder="translate('simcard_devices.tariff_ap')" :readonly="true" />
            </div>
          </div>

          <div class="line">
            <div class="input_wrap">
              <fg-input v-model="date_update" type="text" :label="translate('simcard_devices.updated')"
                        :placeholder="translate('simcard_devices.updated')" :readonly="true" />
            </div>

            <div class="input_wrap">
              <fg-input v-model="date_sync" type="text" :label="translate('simcard_devices.ts_sync')"
                        :placeholder="translate('simcard_devices.ts_sync')" :readonly="true" />
            </div>
          </div>

          <div v-if="profile.description" class="line">
            <div class="input_wrap form-group">
              <label>{{ translate('simcard_devices.description') }}</label>
              <textarea
                  v-model="profile.description"
                  rows="3"
                  :readonly="true"
                  class="form-control border-input"
                  :placeholder="translate('simcard_devices.description')"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="simcard_list">
        <RelatedProfiles
            v-if="profile.related_profiles"
            title="Related Profiles"
            :simcard_list="profile.related_profiles"
        />
      </div>

      <div class="device_list">
        <DeviceHistory
            :title="translate('simcard_devices.section.device_history')"
            :profile="profile"
        />
      </div>
    </div>

    <div class="history_action__wrap">
      <Summary
        type="simcard_devices"
        :info="simcard"
      />
    </div>
  </div>

</template>
<script>

import SisSelect from 'components/UIComponents/Inputs/SisSelect.vue'
import SisIconStatus from 'components/UIComponents/Icon/SisIconStatus.vue'
import Summary from "components/UIComponents/Summary/Summary.vue";
import DeviceHistory from './DeviceHistory.vue'
import LinkedSimCard from 'components/UIComponents/Icon/LinkedSimCard.vue'
import RelatedProfiles from './RelatedProfiles.vue'
import EditProfileModal from "./Edit/Index.vue";

import GlobalConfirm from "components/UIComponents/Confirm/GlobalConfirm";

export default {
  components: {
    SisSelect,
    SisIconStatus,
    Summary,
    DeviceHistory,
    LinkedSimCard,
    RelatedProfiles
  },

  props: {
    profile: {
      type: [Array, Object],
      default: () => []
    },
  },

  created() {
    this.update_sim()
    this.check_links(this.profile)
  },
  data () {
    return {
      ch_group: false,
      showBlock: true,
      simcard: {
        type: [Array, Object],
        default: () => []
      },
      editNumber: true,
      editOperator: true,
      uptimeStr: "",
      links: {},
    }
  },

  computed: {
    binding_created(){
      return this.get_date(this.simcard.bindings.ts_create)
    },
    binding_updated(){
      return this.get_date(this.simcard.bindings.ts_update)
    },
    binding_verify(){
      return this.get_date(this.simcard.bindings.ts_verify)
    },
    binding_device(){
      return `${this.simcard.bindings.device_fid} / ${this.simcard.bindings.device_name}`
    },
    date_start(){
      return this.simcard.ts_create > 0 ? this.get_date(this.simcard.ts_create ) : ''
    },
    date_update(){
      return this.simcard.ts_update > 0 ? this.get_date(this.simcard.ts_update) : ''
    },
    date_sync(){
      return this.simcard.ts_sync > 0 ? this.get_date(this.simcard.ts_sync) : ''
    },
    simcard_group(){
      return this.$store.getters.getSimcardDevicesGroupById(this.simcard.group_id)
    },
    balance_traffic(){
      return this.traffic_balance(this.simcard.traffic)
    },
    last_update(){
      let ts = new Date().getTime()/1000
      var duration = parseInt(ts - this.simcard.traffic.ts_update);
      let minutes = 0
      let hours = parseInt((duration/(60*60)));
      if (hours < 5) {
        minutes = parseInt((duration/60));
        return minutes + " " + this.translate('simcard_devices.min_ago')
      }
      minutes = parseInt((duration/60)%60);
      return hours + " " + this.translate('simcard_devices.h_ago')
    },
    get_status_from() {
      if (this.profile.ts_status_update){
        return "from " + this.get_date(this.profile.ts_status_update);
      }else{
        return this.translate('simcard_profile.no_lk')
      }
    },
    last_date(){
      return this.get_date(this.simcard.ts_sync, {
        hour12: false,
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      })
    },
    style_traffic() {
      return this.traffic_style(this.simcard.traffic)
    },
  },

  watch : {
    profile: {
      deep: true,
      handler () {
        this.update_sim()
        this.check_links(this.profile)
      }
    }
  },

  methods: {
    pre_unlink_simcard () {
      let t = this.$createElement(GlobalConfirm, {
        props: {
          text: this.translate('simcard_devices.really_want_unlink_simcard')
        },
        on: {
          close: () => {
            this.$modal.hide('unlink_simcard_modal')
          },
          confirm: () => {
            this.unlink_simcard()
            this.$modal.hide('unlink_simcard_modal')
          }
        }
      })
      let temp = { render () { return t } }
      this.$modal.show(temp, {}, {height: 'auto', adaptive: true, clickToClose: false, scrollable: true, name: 'unlink_simcard_modal'})
    },

    unlink_simcard(){
      this.$http.v1.deleteSimcardBinding(this.simcard.bindings.id, (response) => {
        this.global_notify('info', this.translate('simcard_devices.unlinked'))
        this.$emit("change")
      })
    },

    check_links(sim) {
      let links = {}
      for (let index in sim.simcard_data) {
        if (index !== 'status' && index !== 'device_simcard' && sim.simcard_data[index]) {
          links[index] = sim.simcard_data[index]
        }
      }
      this.$set(this, 'links', links)
    },
    update_sim(){
      this.simcard = {...this.profile}
      !this.simcard.number ? this.editNumber = false : this.editNumber = true
      !this.simcard.operator ? this.editOperator = false : this.editOperator = true
    },

    editProfile () {
      let t = this.$createElement(EditProfileModal, {
        props: {
          simcard: this.simcard,
        },
        on: {
          close: () => {
            this.$modal.hide('edit_simcard_device')
          }
        }
      })
      let temp = { render () { return t } }
      this.$modal.show(temp, {}, {height: 'auto', adaptive: true, clickToClose: true, scrollable: true, name: 'edit_simcard_device'})
    },

    cancel () {
      this.init = true
      this.simcard = {...this.profile}
    },
  }
}

</script>

<style lang='scss' scoped>

  .simcard_list{
    padding-top: 10px;
  }
  .non_card{
    padding-left: 0;
    padding-right: 0;
    width: calc(70% - 10px);
    margin-right: 10px;
    &__wrap{
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
    }

    .header-profile {
      padding-bottom: 10px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      &.blocked{
        border: 2px solid #EB5E28;
        .simcard_blocked{
          position: absolute;
          right: 0;
          top: 0;
          height: 100%;
          width: 10%;
          min-width: 150px;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: #EB5E28;
          color: white;
          font-size: 12px;
        }
      }
      .linked-cards{
        height: 100px;
        display: flex;
        cursor: pointer;
        margin-left: 10px;
        .linked-card__wrap{
          height: 100%;
          margin-right: 5px;
          &:last-child{
            margin-right: 0;
          }
        }
      }
    }
    .button_div {
      padding-bottom: 10px;
      padding-top: 5px;
    }

    .version {
      font-size: 10px;
      color: #9A9A9A;
    }

    .table_ip_tr {
      background-color: #eee !important;
    }

  }
  .content{
    .card {
      padding: 10px;
      margin-right: 0;
      width: 100%;
    }
    .title{
    position: relative;
      h4{
        font-size: 12px;
        line-height: 120%;
        font-weight: bold;
        color: #252422;
        margin-top: 0;
        margin-bottom: 10px;
      }
    }
    .line{
      display: flex;
      align-items: center;
      justify-content: space-between;
      .input_wrap{
        flex: 1;
        margin: 0 2.5px;
        position: relative;
        &:last-child{
          margin-right: 0;
        }
        &:first-child{
          margin-left: 0;
        }
        .mno_link{
          .mdi{
            color: #66615b;
          }
        }

      }
    }
  }

  .edit{
    position: absolute;
    top: 6px;
    right: 10px;
    width: 16px;
    height: 16px;
    text-align: center;
    vertical-align: middle;
    font-size: 20px;
    color: #66615b;
    transition: 0.2s;
    cursor: pointer;
    z-index: 5;
    &:hover{
      color: #41B883;
    }
  }

  .history_action__wrap{
    width: 30%;
    height: 100%;
    border-radius: 3px;
    box-shadow: 0 2px 2px #ccc5b980;
    color: #252422;
    position: relative;
    border: 1px solid #ccc;
    background-color: #f8f8f8;
  }

  .bindings {
    width: 100%;
    padding-bottom: 10px;

    .header{
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;
    }

    .title{
      position: relative;
      h4{
        font-size: 12px;
        line-height: 120%;
        font-weight: bold;
        color: #252422;
        margin: 0;
      }
    }

    .button{

    }
    .card{
      width: 100%;
      padding: 10px;
      background-color: #dbf2e878;
      a{
        display: flex;
        justify-content: space-around;
      }
      .form-group{
        width: 100%;
      }
      span{
        font-size: 12px;
        line-height: 120%;
        font-weight: bold;
        color: #252422;
      }
    }
  }

  @media (max-width:1350px){
    .card{
      width: 100%;
      height: auto;
      min-height: inherit;
      margin-bottom: 10px;
      &__wrap{
        height: auto;
        flex-direction: column;
        padding-bottom: 10px;
      }
    }
    .history_action__wrap{
      width: 100%;
      height: auto;
    }
  }


  @media (max-width:767px){
    .card{
      .header-profile {
        &.blocked{
          .simcard_blocked{
            position: inherit;
            height: 100%;
            width: calc(100% + 16px);
            margin: 10px 0px -10px -8px;
            padding: 5px;
            min-width: inherit;
          }
        }
      }
      .content{
        .line{
          flex-wrap: wrap;
          flex-direction: column;
          .input_wrap{
            width: 100%;
          }
        }
      }
    }
  }

  @media (max-width:550px){
    .card{
      .header-profile {
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;

        .linked-cards{
          margin: 10px auto;
        }
      }
    }
  }
</style>
